export default function drIds() {
  const doctor    = JSON.parse(localStorage.getItem('user'));
  const location  = JSON.parse(localStorage.getItem('practice_location'));
  return '&eb_doctor_id=' + doctor?.id + '&eb_location_id=' + location?.id;
}